import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import useReveal from "@/hooks/useReveal";
import { useCurrency } from "@/context/CurrencyContext";
import { Check, ArrowRight } from "@phosphor-icons/react";

export default function WebPackages() {
  const ref = useReveal();
  const { format } = useCurrency();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/web-packages").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <section id="web" ref={ref} data-testid="web-packages" className="reveal section border-b border-[color:var(--line)] bg-white">
      <div className="container-x">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <div className="eyebrow">Web development</div>
            <h2 className="font-display font-black text-4xl md:text-5xl mt-4 leading-[1.02] max-w-2xl">
              Fixed-price web packages. Zero scope creep.
            </h2>
          </div>
          <p className="text-neutral-600 max-w-md">
            Pick a tier, pay a fixed price, ship in a fixed window. Switch currency at the top nav to see local pricing.
          </p>
        </div>

        <div className="grid md:grid-cols-3 border-l border-t border-[color:var(--line)]">
          {items.map((pkg) => (
            <div
              key={pkg.id}
              data-testid={`web-pkg-${pkg.name.toLowerCase().replace(/\s+/g, "-")}`}
              className={`relative border-r border-b border-[color:var(--line)] p-8 flex flex-col transition-all ${
                pkg.highlight ? "bg-[color:var(--brand)]/5 border-[color:var(--brand)] shadow-[0_20px_40px_-20px_rgba(30,136,240,0.35)]" : "hover:bg-neutral-50"
              }`}
            >
              {pkg.highlight && (
                <span className="absolute top-4 right-4 font-mono text-[10px] uppercase tracking-widest bg-[color:var(--brand)] text-white px-2 py-1">
                  Most picked
                </span>
              )}
              <div className="eyebrow">{pkg.tagline}</div>
              <h3 className="mt-3 font-display font-bold text-2xl">{pkg.name}</h3>
              <div className="mt-6 flex items-baseline gap-2">
                <span className="font-display font-black text-4xl">{format(pkg.price_inr)}</span>
                <span className="font-mono text-xs uppercase tracking-widest text-neutral-500">fixed</span>
              </div>
              <ul className="mt-6 space-y-3 flex-1">
                {pkg.features.map((f) => (
                  <li key={f} className="text-sm flex gap-2 items-start text-neutral-700">
                    <Check size={16} weight="bold" className="text-[color:var(--brand)] mt-1" />
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href={`https://wa.me/7054986771?text=${encodeURIComponent(`I'm interested in the ${pkg.name} package.`)}`}
                target="_blank" rel="noreferrer"
                data-testid={`web-pkg-cta-${pkg.name.toLowerCase().replace(/\s+/g, "-")}`}
                className={`mt-8 inline-flex items-center gap-2 py-3 px-4 font-semibold transition-colors duration-200 justify-center ${
                  pkg.highlight ? "bg-[color:var(--brand)] text-white hover:bg-[color:var(--brand-dark)]" : "border border-[color:var(--ink)] hover:bg-[color:var(--ink)] hover:text-white"
                }`}
              >
                Start on WhatsApp <ArrowRight size={16} weight="bold" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
